import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RiPlantLine, RiMoneyDollarCircleLine } from "react-icons/ri";
import { BiArea, BiGlobe } from "react-icons/bi";
import { GrDocumentPpt } from "react-icons/gr";
import { GiForestCamp } from "react-icons/gi";
import { Property } from "@/models/Property";
import { LuAlertCircle, LuCircleDashed } from "react-icons/lu";
import { MdOutlineLocationOn } from "react-icons/md";
import { HiOutlineCursorClick } from "react-icons/hi";
import { useAuth } from "@/context/AuthContext";
import { RiVerifiedBadgeFill } from "react-icons/ri";

const PropertyInformations = ({
  property,
  propertyVisits,
  openModalCheckpoint,
}: {
  property: Property;
  propertyVisits: number,
  openModalCheckpoint: () => void;
}) => {
  const lng = localStorage.getItem("language");
  const { t } = useTranslation();
  const { user } = useAuth();

  const InfoRow = ({
    label,
    value,
    icon,
  }: {
    label: string;
    value: any;
    icon: React.ReactNode;
  }) => (
    <div className="!flex !flex-row text-[18px]">
      <div className="flex flex-row items-start gap-2 flex-1">
        {icon}
        <strong>{label}</strong>
      </div>
      <p className="text-[#50700f]">{value}</p>
    </div>
  );

  return (
    <div className="w-full lg:w-1/2">
      <div className="flex items-center gap-4 mb-4">
        <h1 className="!text-4xl !font-semibold text-[#50700f] flex">
          {lng === "en" ? property.name_en : property.name} {property.verified_forested_area === 1 && <RiVerifiedBadgeFill color="#64d0ea" size={24} />}
        </h1>
        {property.status === "legal_diligence" || property.status === "diligence" || property.status === "rejected" ? (
          <button
            onClick={() => openModalCheckpoint()}
            className={`flex items-center gap-2 !px-3 !py-1 rounded-md !text-white text-sm font-medium ${
              (property.status === "legal_diligence" || property.status === "diligence")
                ? "!bg-yellow-500 !border !border-yellow-700"
                : "!bg-[#FF7575] !border !border-red-700"
            }`}
          >
            {(property.status === "legal_diligence" || property.status === "diligence") ? (
              <LuAlertCircle size={20} />
            ) : (
              <LuCircleDashed size={20} />
            )}
            {t(property.status)}
          </button>
        ) : null}
      </div>

      <div className="!border-2 !rounded-br-3xl !rounded-tl-3xl p-6 flex flex-col gap-5">
        {property.status !== "catalog" && (
          <InfoRow
            icon={<RiMoneyDollarCircleLine color="#50700f" size={24} />}
            label={t("price")}
            value={property.cost_formatted}
          />
        )}
        <InfoRow
          icon={<MdOutlineLocationOn color="#50700f" size={24} />}
          label={t("address")}
          value={property.address}
        />
        <InfoRow
          icon={<BiGlobe color="#50700f" size={24} />}
          label={t("Latitude")}
          value={parseFloat(property.lat || "0").toFixed(4)}
        />
        <InfoRow
          icon={<BiGlobe color="#50700f" size={24} />}
          label={t("Longitude")}
          value={parseFloat(property.lng || "0").toFixed(4)}
        />
        <InfoRow
          icon={<BiArea color="#50700f" size={24} />}
          label={t("hectares")}
          value={property.acre}
        />
        <InfoRow
          icon={<BiArea color="#50700f" size={24} />}
          label={t("preserved_area")}
          value={property.preserved_area}
        />
        {/*property.status !== "catalog" && (
                  <>
                    <InfoRow
                      icon={<GrDocumentPpt color="#50700f" size={24}/>}
                      label={t("deed-number")}
                      value={property.deed_number}
                    />
                    <InfoRow
                      icon={<GrDocumentPpt color="#50700f" size={24}/>}
                      label={t("number-doc")}
                      value={property.cib_nirf_number}
                    />
                  </>
                )*/}
        <InfoRow
          icon={<GiForestCamp color="#50700f" size={24} />}
          label={t("vegetation")}
          value={t(`vegetation-${property.vegetation}`)}
        />
        <InfoRow
          icon={<RiPlantLine color="#50700f" size={24} />}
          label={t("carbon_credits_available")}
          value={
            property.carbon_credits_available > 0
              ? property.carbon_credits_available
              : 0
          }
        />
        {property.user_id === user?.id && propertyVisits > 0 && (
          <InfoRow
            icon={<HiOutlineCursorClick color="#50700f" size={24} />}
            label={t("visits")}
            value={
              propertyVisits
            }
          />
        )}
      </div>

      {property.status !== 'legal_diligence' && <div className="flex items-center justify-between gap-4 mt-4">
        <h2 className="!text-xl">Situação da Propriedade</h2>
        <span
          className={`p-2 !bg-yellow-500 !border-2 !border-yellow-700" w-1/4 rounded-lg text-center font-medium text-xl`}
        >
          {t(property.status)}
        </span>
      </div>}
    </div>
  );
};

export default PropertyInformations;
